
<!-- /src/app/app.component.html -->
<router-outlet></router-outlet>

<!-- El spinner global vivirá aquí -->
<app-spinner></app-spinner>
